"use client";
import React, { useEffect, useState } from "react";
import { useEmployees } from "../context/EmployeeContext";

export default function ProfilePage() {
  const { getEmployeeById } = useEmployees();

  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployee = async () => {

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = user?.id || null;

      if (!userId) return;

      const data = await getEmployeeById(userId);
      setEmployee(data);
      setLoading(false);
    };

    fetchEmployee();
  }, [getEmployeeById]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">Loading profile...</p>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-red-600">Failed to load profile</p>
      </div>
    );
  }

  return (
     <div className="min-h-screen bg-sky-50 px-8 py-4">
    <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">
      My Profile
    </h1>

    <div className="bg-white rounded-2xl shadow p-8">
      <form className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <Input label="First Name" name="first_name" defaultValue={employee.first_name} />
          <Input label="Last Name" name="last_name" defaultValue={employee.last_name} />
          <Input label="Email Address" name="email" type="email" defaultValue={employee.email} />
          <Input label="Phone Number" name="phone" defaultValue={employee.phone} />

          {/* Gender */}
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700">
              Gender
            </label>
            <div className="flex gap-6 mt-2">
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="gender"
                  value="Male"
                  disabled
                  defaultChecked={employee.gender === "male"}
                />
                Male
              </label>
              <label className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="gender"
                  value="Female"
                  disabled
                  defaultChecked={employee.gender === "female"}
                />
                Female
              </label>
            </div>
          </div>

          {/* Address */}
         {/* Address */}
<div className="col-span-1 md:col-span-2 lg:col-span-2">
  <label className="block text-sm font-medium mb-1 text-gray-700">
    Address
  </label>
  <textarea
    readOnly
    name="address"
    rows={3}
    defaultValue={employee.address}
    className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#8c57ff]/40 focus:border-[#8c57ff]/40"
  />
</div>
          <Input label="Postcode" name="postcode" defaultValue={employee.postcode} />
          <Input
            label="Joining Date"
            name="joiningDate"
            type="date"
            defaultValue={employee.joiningdate}
          />

          <Input label="Bank Name" name="bank" defaultValue={employee.bank} />
          <Input label="IFSC Code" name="ifsc" defaultValue={employee.ifsc} />

          <Input label="Account Number" name="acc_no" defaultValue={employee.acc_no} />
          <Input label="PAN Number" name="pan_no" defaultValue={employee.pan_no} />

          <Input label="UAN Number" name="uan_no" defaultValue={employee.uan_no} />
          <Input label="Salary" name="salary" defaultValue={employee.salary} />
        </form>
      </div>
    </div>
  );
}

/* ---------- Reusable Input Component ---------- */
function Input({ label, name, type = "text", defaultValue }) {
  return (
    <div className="w-full">
      <label className="block text-sm font-medium mb-1 text-gray-700">
        {label}
      </label>
      <div className="focus-within:ring-2 focus-within:ring-[#8c57ff]/40 focus-within:border-[#8c57ff]/40 rounded-lg">
        <input
          name={name}
          type={type}
          readOnly
          defaultValue={defaultValue || ""}
          className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:outline-none"
        />
      </div>
    </div>
  );
}